module.exports = __webpack_public_path__ + "img/310x430.a24e9d46.png";